module.exports = __webpack_public_path__ + "static/img/mobilegreen3.b3efa1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobilegreen3.png
// module id = GS+Z
// module chunks = 1